import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {ArrowLeft, Mail} from 'lucide-react';
import {MemberEmailDelivery, membersEmailApi} from '../../services/membersEmailApi.ts';
import {membersError} from '../../services/membersApi.ts';
import {useTheme} from '../../contexts/ThemeContext.tsx';
import {Card, Loading, Notice, Pagination} from './MembersShared.tsx';

const kinds: Record<string, string> = {
  financial_status: 'Atualização do cadastro financeiro',
  password_reset: 'Recuperação de senha', welcome: 'Boas-vindas', registration_submitted: 'Cadastro enviado',
  partner_approved: 'Cadastro aprovado', onboarding_approved: 'Cadastro aprovado',
  onboarding_pending: 'Pendência no cadastro', referral_created: 'Indicação recebida',
};
const statuses: Record<string, string> = {
  request: 'Aceito pelo Brevo', click: 'Link acessado', unique_opened: 'Aberto', deferred: 'Entrega adiada', error: 'Falha de entrega',
  pending: 'Aguardando envio', queued: 'Na fila', sending: 'Em envio', sent: 'Aceito pelo Brevo',
  delivered: 'Entregue', failed: 'Falha no envio', retry: 'Aguardando nova tentativa',
  cancelled: 'Envio cancelado', expired: 'Envio expirado', uncertain: 'Envio em conferência', bounce: 'Endereço recusado',
  suppressed: 'Envio suspenso', skipped: 'Não enviado', blocked: 'Bloqueado',
  hardbounce: 'Endereço recusado', softbounce: 'Falha temporária',
  hard_bounce: 'Endereço recusado', soft_bounce: 'Falha temporária', invalid_email: 'Endereço inválido',
  unsubscribed: 'Inscrição cancelada', spam: 'Marcado como spam', opened: 'Aberto', clicked: 'Link acessado',
};
export default function MembersEmailHistory() {
  const {isDark} = useTheme();
  const [items, setItems] = useState<MemberEmailDelivery[]>([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let current = true;
    setBusy(true); setError('');
    void membersEmailApi.history(offset).then(result => {if (current) {setItems(result.items); setTotal(result.total);}}).catch(err => {if (current) setError(membersError(err));}).finally(() => {if (current) setBusy(false);});
    return () => {current = false;};
  }, [offset, retry]);
  return (
    <div className={`members-theme min-h-screen p-4 sm:p-8 ${isDark ? 'members-theme-dark' : ''}`}>
      <div className="mx-auto max-w-[1120px] space-y-6">
        <Link className="members-link inline-flex items-center gap-2 text-sm" to="/members/admin"><ArrowLeft size={16} />Administração de parceiros</Link>
        <h1 className="text-2xl font-semibold">Histórico de e-mails</h1>
        <p className="members-secondary text-sm">Acompanhe as solicitações de envio e as atualizações de entrega.</p>
        {busy ? <Loading /> : error ? <Notice error>{error} <button className="underline" onClick={() => setRetry(value => value + 1)}>Tentar novamente</button></Notice> : <Card>
          {items.length ? <div className="divide-y divide-[var(--members-border)]">{items.map(item => <article className="flex flex-col justify-between gap-3 py-4 sm:flex-row" key={item.id}>
            <div><h2 className="text-sm font-medium">{kinds[item.kind] || 'Atualização da conta'}</h2><p className="members-muted mt-2 text-xs">Parceiro #{item.partner_id} · {new Date(item.created_at).toLocaleString('pt-BR')}</p></div>
            <div className="text-sm sm:text-right"><p>{statuses[item.status] || 'Em acompanhamento'}</p>{item.event_status && <p className="members-muted mt-2 text-xs">Entrega: {statuses[item.event_status.toLowerCase()] || 'Em acompanhamento'}</p>}</div>
          </article>)}</div> : <div className="py-10 text-center"><Mail className="members-link mx-auto mb-3" size={28} /><p className="text-sm">Nenhum envio registrado.</p></div>}
          <Pagination offset={offset} total={total} onChange={setOffset} />
        </Card>}
      </div>
    </div>
  );
}
